<template lang='pug'>
  blue-layout(:user='user' :account='account' :biz='biz')
    template(v-slot:header)
      blank-header

    #not-found.view.no-header
      bf-wrapper.content.centered-text.full
        bf-divider.section.borderless
        router-link( :to='{ path: user ? account.merchant ? "/dashboard" : "/welcome" : "/"}' )
          img(src='/ui/404laptop.svg')
        bf-divider.section.borderless
        h1 {{$t("Page Not Found")}}
        bf-divider.section.borderless
        router-link( :to='{ path: user ? account.merchant ? "/dashboard" : "/welcome" : "/"}' )
          bf-button.large
            template(slot='text') {{ $t('Home') }}
        bf-divider.section.borderless
        
</template>

<<<<<<< HEAD
=======
</template>

>>>>>>> staging2
<script>
  import { View } from '@/mixins/view'
  import BlankHeader from '@/components/blank-header'

  export default {
    name: 'not-found.view',

    mixins: [ View ],

    components: {
      BlankHeader
    }
  }
</script>

<style scoped lang='stylus'>
  .full
    background lightblue
</style>
